import { useContext } from 'react';
import { AuthContext, IAuthContext } from 'context';

const useAuth = (): IAuthContext => useContext(AuthContext);

export default useAuth;
